import { useAppDispatch, useAppSelector } from '~/store/redux-hook';

import { searchSlice } from './searchSlice';

export const useSearchSelector = () => {
  return useAppSelector((state) => state.search.searchValue);
};

export const useSongsFoundSelector = () => {
  return useAppSelector((state) => state.search.songsFound);
};

export const useArtistFoundSelector = () => {
  return useAppSelector((state) => state.search.artistsFound);
};

export const usePlaylistsFoundSelector = () => {
  return useAppSelector((state) => state.search.playlistFound);
};

export const useResultCountSelector = () => {
  return useAppSelector((state) => state.search.resultCount);
};

export const useSetSearchValue = () => {
  const dispatch = useAppDispatch();

  return (payload: string) => {
    dispatch(searchSlice.actions.setSearchValue(payload));
  };
};
